export const OrderReceiptTemplate = (
  orderData,
  user,
  fullAddress,
  allSum,
  productsInCart,
  deliveryPrice,
) => {
  const delivery = parseFloat(deliveryPrice || 0);
  const brandColor = "#e2062c";
  const darkSlate = "#2d3436";
  const now = new Date();
  const dateTimeStr =
    now.toLocaleDateString("he-IL") +
    " | " +
    now.toLocaleTimeString("he-IL", { hour: "2-digit", minute: "2-digit" });

  return `
    <div style="direction: rtl; padding: 50px; font-family: 'Segoe UI', Roboto, Helvetica, Arial, sans-serif; color: ${darkSlate}; background-color: white; width: 100%; box-sizing: border-box; max-width: 850px; margin: 0 auto; line-height: 1.6; -webkit-font-smoothing: antialiased;">
        
        <div style="display: flex; justify-content: space-between; align-items: flex-start; margin-bottom: 50px;">
            <div style="text-align: right;">
                <img src="https://wstest.hamazon.co.il/img/iconcss/site-icon.svg" alt="המזון" style="height: 30px; width: auto; display: block; margin-bottom: 12px;" />
            </div>
            <div style="text-align: left; font-size: 13px; color: #636e72;">
                <div style="font-weight: 700; color: ${darkSlate}; font-size: 15px; margin-bottom: 4px;">hamazon.co.il</div>
                <div>02-5327277</div>
                <div style="margin-top: 5px; font-size: 12px; color: #95a5a6;">${dateTimeStr}</div>
            </div>
        </div>

        <div style="display: flex; justify-content: space-between; margin-bottom: 45px; border-bottom: 1px solid #f1f2f6; padding-bottom: 30px;">
            <div style="flex: 1.5;">
                <div style="font-size: 18px; font-weight: 700; color: ${darkSlate}; margin-bottom: 4px;">${user.Name} ${user.LastName || ""}</div>
                <div style="font-size: 14px; color: #636e72;">${fullAddress}</div>
                <div style="font-size: 14px; color: #636e72;">${user.Phone || ""}</div>
            </div>
            <div style="flex: 1; text-align: left;">
                <div style="font-size: 14px; margin-bottom: 3px;"><strong>מספר הזמנה:</strong> ${orderData.id || orderData.OrderWebId || ""}</div>
            </div>
        </div>

        <table style="width: 100%; border-collapse: collapse; margin-bottom: 30px;">
            <thead>
              <tr style="border-bottom: 2px solid ${darkSlate};background-color:${brandColor};">
                    <th style="padding: 12px 5px; text-align: right; font-size: 12px; font-weight: 700; color: ${darkSlate};">שם המוצר</th>
                    <th style="padding: 12px 5px; text-align: center; font-size: 12px; font-weight: 700; color: ${darkSlate}; width: 100px;">ברקוד</th>
                    <th style="padding: 12px 5px; text-align: center; font-size: 12px; font-weight: 700; color: ${darkSlate}; width: 110px;">מחיר יחידה</th>
                    <th style="padding: 12px 5px; text-align: center; font-size: 12px; font-weight: 700; color: ${darkSlate}; width: 60px;">כמות</th>
                    <th style="padding: 12px 5px; text-align: left; font-size: 12px; font-weight: 700; color: ${darkSlate}; width: 100px;">סה"כ</th>
                </tr>
            </thead>
            <tbody>
               ${productsInCart
                 .map((p) => {
                   const unitPrice = parseFloat(p.unitPrice || p.price || 0);
                   const quantity = parseInt(p.quantity || 1);
                   const totalPaid = parseFloat(
                     p.totalPrice || unitPrice * quantity,
                   );
                   const actualUnitPrice = totalPaid / quantity;
                   const hasDiscount = unitPrice * quantity - totalPaid > 0.01;

                   return `
        <tr style="border-bottom: 1px solid #f1f2f6;">
            <td style="padding: 18px 5px; font-size: 14px; font-weight: 500;">${p.product?.name || p.name}</td>
            <td style="padding: 18px 5px; text-align: center; font-size: 11px; color: #95a5a6; font-family: monospace;">${p.product?.gtin || p.gtin || "-"}</td>
            <td style="padding: 18px 5px; text-align: center; font-size: 14px;">
                ${hasDiscount ? `<div style="text-decoration: line-through; color: #95a5a6; font-size: 11px; line-height: 1;">₪${unitPrice.toFixed(2)}</div>` : ""}
                <div style="font-weight: 500;">₪${actualUnitPrice.toFixed(2)}</div>
            </td>
            <td style="padding: 18px 5px; text-align: center; font-size: 14px;">${quantity}</td>
            <td style="padding: 18px 5px; text-align: left; font-size: 14px; font-weight: 600;">₪${totalPaid.toFixed(2)}</td>
        </tr>`;
                 })
                 .join("")}
            </tbody>
        </table>

        <div style="display: flex; justify-content: flex-end; margin-top: 20px;">
            <div style="width: 280px; background-color: #fafbfc; padding: 25px; border-radius: 4px;">
                <div style="display: flex; justify-content: space-between; font-size: 13px; color: #636e72; margin-bottom: 10px;">
                    <span>סיכום ביניים</span>
                    <span>₪${(allSum - delivery).toFixed(2)}</span>
                </div>
                ${
                  delivery > 0
                    ? `
                <div style="display: flex; justify-content: space-between; font-size: 13px; color: #636e72; margin-bottom: 10px;">
                    <span>דמי משלוח</span>
                    <span>₪${delivery.toFixed(2)}</span>
                </div>`
                    : ""
                }
                <div style="display: flex; justify-content: space-between; font-size: 18px; font-weight: 800; border-top: 1px solid #dfe6e9; padding-top: 15px; margin-top: 5px; color: ${darkSlate};">
<span style="font-weight: 700; color: ${darkSlate}; letter-spacing: -0.5px;">סה"כ לתשלום</span>
                    <span style="font-weight: 700; color: ${brandColor};">₪${allSum.toFixed(2)}</span>
                </div>
            </div>
        </div>

        <div style="margin-top: 60px; text-align: center;">
            <div style="font-size: 11px; color: #b2bec3; margin-top: 6px;">
                שימו לב יתכנו סטיות קטנות בהתאם למלאי.
            </div>
        </div>
    </div>`;
};
